import { Box, TextField, TextareaAutosize, Button } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik } from "formik";
import * as yup from "yup";
import "./deletionRequests.css";
import axios from "axios";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../COMPONENTS/header/Header";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import { useLocation } from "react-router-dom";
import AuthContext from "../../../CONTEXT/AuthProvider";
import { useContext } from "react";

const ViewDeletionRequest = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const location = useLocation();
  const { auth } = useContext(AuthContext);
  const role = auth.role;
  const staff = auth.staff;
  const status = location.state.deletionRequestDetails.status;

  const handleFormSubmit = async (values) => {
    const responseFileUpload = values.responseFileUpload;
    const id =location.state.deletionRequestDetails.id;
    try {
      const formData = new FormData();
      formData.append("responseFileUpload", responseFileUpload);
      formData.append("id", id);

      console.log(responseFileUpload);

      const response = await axios.post("/api/upload-response-file", formData, [id]);
      toast.success(response.data.success, {
        position: toast.POSITION.TOP_CENTER,
      });
    } catch (err) {
      toast.error(err.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleComplete = (id) => {
    axios
      .post(
        "/api/complete-deletion",
        { id }
      )
      .then((response) => {
        toast.success(response.data.success, {
          position: toast.POSITION.TOP_CENTER,
        });
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Header
            title="VIEW DELETION REQUEST"
            subtitle="View deletion request details"
          />

          <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}>
            {({
                values,
                handleSubmit,
              }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    type="text"
                    label="BOT Written Date"
                    value={
                      location.state.deletionRequestDetails.botWrittenDate
                    }
                    name="bot"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="CIT Received Date"
                    value={location.state.deletionRequestDetails.citReceivedDate}
                    name="cit"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextareaAutosize
                    minRows={4}
                    aria-label="Subject Name *"
                    value={location.state.deletionRequestDetails.subject}
                    name="subject"
                    className="textArea"
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Subscriber"
                    value={location.state.deletionRequestDetails.subscriber}
                    name="created"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  {(staff && role === "compliance" && status === 'In Progress') && (
                    <input
                    type="file"
                    name="responseFileUpload"
                    placeholder="Select a file"
                    onChange={(event) => {
                      values.responseFileUpload = event.target.files[0];
                    }}
                    className="responseFile"
                  />
                  )}
                </Box>
                {(staff && role === "compliance" && status === 'In Progress') && (
                <Box display="flex" justifyContent="end" mt="20px">
                  <Button type="submit" color="success" variant="contained" onClick={() => handleComplete(location.state.deletionRequestDetails.id)}>
                    Complete
                  </Button>
                </Box>
                )}
                <ToastContainer />
              </form>
            )}
          </Formik>
        </Box>
      </main>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  responseFileUpload: yup.string().required("required")
});
const initialValues = {
  responseFileUpload: ""
};

export default ViewDeletionRequest;